import React, { Fragment, useState } from "react";

import {
  IonItem,
  IonLabel,
  IonIcon,
  IonPopover,
  IonListHeader,
  IonSpinner,
  IonList
} from "@ionic/react";

import {
  PassageFormError,
  PassageForm,
  VacancyGrouped
} from "../../../interfaces/passage";

import Loading from "../../../components/Ui/Loading";
import injectContext from "../useContext";
import useGrouping from "../useGrouping";
import useVacancySearch from "../useVacancySearch";

import { timeOutline, checkmarkOutline } from "ionicons/icons";

interface TimeSelectProps {
  formError: PassageFormError;
  vacancies: any[];
  loading: boolean;
  onIonChange: (event: any) => void;
}

interface TimeSelectListProps {
  vacancies: any[];
  date: string;
  departure_location_id?: string;
  arrival_location_id?: string;
  onChange: (value: VacancyGrouped) => void;
  minutes?: string;
  hour?: string;
}

const TimeSelectList: React.FC<TimeSelectListProps> = ({
  date,
  departure_location_id,
  arrival_location_id,
  onChange,
  minutes,
  hour
}) => {
  const { list, loading } = useVacancySearch("getVacancies", {
    date,
    departure_location_id,
    arrival_location_id
  });

  const { vacanciesGroupHourMinutes } = useGrouping(
    list,
    date,
    arrival_location_id,
    departure_location_id
  );

  return (
    <IonList style={{ maxHeight: 400, minHeight: 400, overflowY: "auto" }}>
      {vacanciesGroupHourMinutes.map((row: VacancyGrouped, index: number) => (
        <IonItem button onClick={() => onChange(row)} key={`item-${index}`}>
          <IonLabel
            color={
              minutes === row.minutes && row.hour === hour
                ? "primary"
                : undefined
            }
          >
            {row.hour}:{row.minutes}
          </IonLabel>
          {minutes === row.minutes && row.hour === hour ? (
            <IonIcon color="primary" icon={checkmarkOutline} slot="end" />
          ) : null}
        </IonItem>
      ))}
      <Loading show={loading} />
    </IonList>
  );
};

const TimeSelect: React.FC<TimeSelectProps & PassageForm> = ({
  formError,
  vacancies,
  hour,
  minutes,
  loading,
  departure_location_id,
  arrival_location_id,
  date,
  onIonChange
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const onChange = (row: VacancyGrouped) => {
    onIonChange({
      detail: {
        value: row.hour,
        name: "hour"
      }
    });
    onIonChange({
      detail: {
        value: row.minutes,
        name: "minutes"
      }
    });
    setOpen(false);
  };
  return (
    <Fragment>
      <IonItem
        button
        disabled={vacancies.length === 0 || formError.is_expired}
        lines="inset"
        onClick={() => {
          setOpen(true);
        }}
      >
        <IonIcon className="icon" slot="start" icon={timeOutline} />
        <IonLabel>Horário</IonLabel>
        <div>
          {(hour || parseInt(hour as any) === 0) && minutes ? (
            <span>
              {hour}:{minutes}
            </span>
          ) : loading ? (
            <IonSpinner />
          ) : (
            <span className={"hour-span"}>Selecione o horário</span>
          )}
        </div>
      </IonItem>
      <IonPopover isOpen={open} onDidDismiss={() => setOpen(false)}>
        <IonListHeader>Selecione o horário</IonListHeader>
        <TimeSelectList
          date={date}
          vacancies={vacancies}
          departure_location_id={departure_location_id}
          arrival_location_id={arrival_location_id}
          hour={hour}
          minutes={minutes}
          onChange={onChange}
        />
      </IonPopover>
    </Fragment>
  );
};

export default injectContext(TimeSelect);
